/* ═══ DRAWER MOBILE ═══ */
function openDrawer() {
  document.getElementById('drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  document.getElementById('drawer').classList.remove('open');
  document.body.style.overflow = '';
}

/* ═══ FAQ ACCORDION ═══ */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq').forEach(function(faq) {
    faq.addEventListener('click', function() {
      faq.classList.toggle('open');
    });
  });
});

/* ═══ PRODUCT OPTIONS ═══ */
function pickFin(el) {
  el.parentElement.querySelectorAll('.pd-f').forEach(function(f) { f.classList.remove('sel'); f.setAttribute('aria-pressed', 'false'); });
  el.classList.add('sel');
  el.setAttribute('aria-pressed', 'true');

  if (typeof PRODUCT_VARIANTS === 'undefined') return;

  var selected = [];
  document.querySelectorAll('.pd-opts').forEach(function(group) {
    var sel = group.querySelector('.pd-f.sel');
    if (sel) selected.push(sel.dataset.value);
  });

  var variant = PRODUCT_VARIANTS.find(function(v) {
    return selected.every(function(val, i) {
      return v['option' + (i + 1)] === val;
    });
  });

  if (!variant) return;

  var price = Math.round(parseFloat(variant.price) / 100);
  document.querySelectorAll('.pd-price, .pd-price-live').forEach(function(p) { p.textContent = price + ' €'; });
  document.querySelectorAll('input[name="id"]').forEach(function(inp) { inp.value = variant.id; });

  // Image d'illustration : si la variante a une image dédiée, l'afficher, sinon revenir à l'image par défaut
  var splitImg = document.getElementById('pd-split-img');
  if (splitImg && typeof VARIANT_IMAGES !== 'undefined') {
    var src = VARIANT_IMAGES[variant.id] || splitImg.dataset.defaultSrc;
    if (src && splitImg.getAttribute('src') !== src) splitImg.setAttribute('src', src);
  }
}

// Options de la fiche classique au clavier (Entrée / Espace)
document.addEventListener('keydown', function(e) {
  if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('pd-f')) {
    e.preventDefault();
    e.target.click();
  }
});

/* ═══ COLLECTION FILTERS ═══ */
var activeGenre = 'all';
var activeCat = 'all';

function applyFilters() {
  document.querySelectorAll('.prod[data-cat]').forEach(function(c) {
    var catOk = activeCat === 'all' || c.dataset.cat === activeCat;
    var genreOk = activeGenre === 'all' || c.dataset.genre === 'both' || c.dataset.genre === activeGenre;
    c.style.display = (catOk && genreOk) ? '' : 'none';
  });
}

function filterShop(cat, btn) {
  document.querySelectorAll('.fil-btn').forEach(function(b) {
    b.classList.remove('act');
  });
  btn.classList.add('act');
  activeCat = cat;
  applyFilters();
}

function filterGenre(genre, btn) {
  document.querySelectorAll('.fil-btn-genre').forEach(function(b) {
    b.classList.remove('act');
  });
  if (activeGenre === genre) {
    activeGenre = 'all';
  } else {
    btn.classList.add('act');
    activeGenre = genre;
  }
  applyFilters();
}

/* ═══ NEWSLETTER POPUP ═══
   Jamais à l'arrivée : seulement après ~30 s passées sur le site (cumulées entre les pages) ET un vrai
   défilement de la page, ou à l'intention de sortie sur ordinateur. Jamais sur les fiches produit ni le
   panier (on ne coupe pas un achat), jamais tant que le bandeau cookies Shopify est affiché. */
(function() {
  var STORAGE_KEY = 'mp_nl_dismissed';
  var FIRST_SEEN_KEY = 'mp_first_seen';
  var store = {
    get: function(s, k) { try { return window[s].getItem(k); } catch (e) { return null; } },
    set: function(s, k, v) { try { window[s].setItem(k, v); } catch (e) {} }
  };
  if (store.get('localStorage', STORAGE_KEY)) return;

  var overlay = document.getElementById('nl-overlay');
  if (!overlay) return;
  var pageType = overlay.dataset.pageType;
  if (pageType === 'product' || pageType === 'cart') return;

  var firstSeen = parseInt(store.get('sessionStorage', FIRST_SEEN_KEY), 10);
  if (!firstSeen) { firstSeen = Date.now(); store.set('sessionStorage', FIRST_SEEN_KEY, String(firstSeen)); }

  var opened = false;
  var scrolledEnough = false;

  function cookieBannerVisible() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && b.offsetParent !== null && getComputedStyle(b).visibility !== 'hidden');
  }

  function openNewsletter() {
    if (opened || store.get('localStorage', STORAGE_KEY) || cookieBannerVisible()) return;
    opened = true;
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function closeNewsletter() {
    overlay.classList.remove('show');
    document.body.style.overflow = '';
    store.set('localStorage', STORAGE_KEY, '1');
  }

  function maybeOpen() {
    if (scrolledEnough && Date.now() - firstSeen >= 30000) openNewsletter();
  }

  window.addEventListener('scroll', function() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.4) scrolledEnough = true;
    maybeOpen();
  }, { passive: true });
  setInterval(maybeOpen, 5000);

  // Ordinateur : la souris sort par le haut de la fenêtre (vers les onglets) après 10 s de visite
  document.addEventListener('mouseout', function(e) {
    if (!e.relatedTarget && e.clientY <= 0 && Date.now() - firstSeen >= 10000) openNewsletter();
  });

  document.getElementById('nl-close').addEventListener('click', closeNewsletter);
  document.getElementById('nl-skip').addEventListener('click', closeNewsletter);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeNewsletter();
  });

  document.getElementById('nl-form').addEventListener('submit', function(e) {
    var email = document.getElementById('nl-email').value.trim();
    var msg = document.getElementById('nl-msg');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.preventDefault();
      msg.textContent = overlay.dataset.invalidEmail;
      msg.style.color = 'var(--rose)';
      return;
    }

    store.set('localStorage', STORAGE_KEY, '1');
  });
})();

/* ═══ STICKY NAV HIGHLIGHT ═══ */
document.addEventListener('DOMContentLoaded', function() {
  var path = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(function(a) {
    if (a.getAttribute('href') === path) {
      a.classList.add('act');
    }
  });
});

/* ═══ NAV TRANSPARENT → SOLIDE AU SCROLL ═══ */
(function() {
  var nav = document.getElementById('main-nav');
  if (!nav) return;
  var isIndex = nav.dataset.page === 'index';
  if (!isIndex) return;

  function updateNav() {
    if (window.scrollY > 40) {
      nav.classList.add('nav--solid');
    } else {
      nav.classList.remove('nav--solid');
    }
  }

  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();
})();

/* ═══ HERO SLIDESHOW ═══ */
(function() {
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  if (slides.length < 2) return;

  var current = 0;
  var timer;

  function heroGoSlide(n) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
    var heroBox = document.querySelector('.hero');
    if (heroBox) heroBox.classList.toggle('hide-copy', current !== 0);
  }

  window.heroGoSlide = heroGoSlide;

  function startTimer() {
    timer = setInterval(function() {
      heroGoSlide(current + 1);
    }, 5500);
  }

  startTimer();

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      clearInterval(timer);
      heroGoSlide(i);
      startTimer();
    });
  });

  var heroEl = document.querySelector('.hero');
  var touchStartX = 0;
  if (heroEl) {
    heroEl.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    heroEl.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 40) return;
      clearInterval(timer);
      heroGoSlide(dx < 0 ? current + 1 : current - 1);
      startTimer();
    }, { passive: true });
  }
})();

/* ═══ BANDEAU D'ANNONCE : ALTERNANCE DES MESSAGES ═══ */
(function() {
  var bar = document.querySelector('[data-bar-rotate]');
  if (!bar) return;
  var msgs = bar.querySelectorAll('.bar-msg');
  if (msgs.length < 2) return;
  var i = 0;
  setInterval(function() {
    msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
  }, 5000);
})();
